var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectOfferRelatedDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.318,
    height: 12.038,
    viewBox: "0 0 10.318 12.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-attachment",
    transform: "translate(-24 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M61.309,35.178H54.86a.861.861,0,0,1-.86-.86v-2.58h.86v2.58h6.449V24.86H57.439V24h3.869a.861.861,0,0,1,.86.86v9.458A.861.861,0,0,1,61.309,35.178Z",
    transform: "translate(-27.85 -11.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M102,60h3.01v.86H102Z",
    transform: "translate(-72.411 -44.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M96,90h3.439v.86H96Z",
    transform: "translate(-66.841 -72.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M90,120h3.869v.86H90Z",
    transform: "translate(-61.271 -100.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M26.15,19.309A2.152,2.152,0,0,1,24,17.159V12.43h.86v4.729a1.29,1.29,0,1,0,2.58,0V13.29a.43.43,0,1,0-.86,0v4.3h-.86v-4.3a1.29,1.29,0,0,1,2.58,0v3.869A2.152,2.152,0,0,1,26.15,19.309Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectOfferRelatedDoc);
export default __webpack_public_path__ + "static/media/Collect Offer Related Doc.bd59ca288391e7202388e8ee13702f09.svg";
export { ForwardRef as ReactComponent };